/*
 * @Author: zhouwei
 * @Date: 2019-11-07 10:11:37
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-04-07 17:17:09
 * @Desc: 来源统计模块
*/
<template>
  <div class="channel">
    <div class="channel-item">
      <div class="channel-pv">
        <div class="title">
          <div class="tips">
            <i></i>
            <span>线索来源（浏览量PV）</span>
          </div>
        </div>
        <div class="wx-data-pv">
          <div
            class="wx-data-pv-item"
            :class="wxDataPv1.length > 0 ? 'show-chart' : ''"
          >
            <div v-if="wxDataPv1.length > 0">
              <mk-pie
                :data="wxDataPv1"
                :tooltip="tooltip"
                :options="pvOptions1"
                :transform="transform"
              ></mk-pie>
            </div>
            <div
              v-else
              class="no-data"
            >
              <div class="no-data-img">
                <img
                  src="@/assets/images/no-data.png"
                  class="img"
                >
              </div>
              <div class="no-data-txt">
                暂无数据
              </div>
            </div>
          </div>
          <div
            class="wx-data-pv-item"
            :class="wxDataPv2.length > 0 ? 'show-chart' : ''"
          >
            <div v-if="wxDataPv2.length > 0">
              <mk-pie
                :data="wxDataPv2"
                :tooltip="tooltip"
                :options="pvOptions2"
                :transform="transform"
              ></mk-pie>
            </div>
            <div
              v-else
              class="no-data"
            >
              <div class="no-data-img">
                <img
                  src="@/assets/images/no-data.png"
                  class="img"
                >
              </div>
              <div class="no-data-txt">
                暂无数据
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="channel-uv">
        <div class="title">
          <div class="tips">
            <i></i>
            <span>线索构成（浏览线索数）</span>
          </div>
        </div>
        <div class="wx-data-uv">
          <div
            class="wx-data-uv-item"
            :class="wxDataUv1.length > 0 ? 'show-chart' : ''"
          >
            <div v-if="wxDataUv1.length > 0">
              <mk-pie
                :data="wxDataUv1"
                :tooltip="tooltip"
                :options="uvOptions1"
                :transform="transform"
              ></mk-pie>
            </div>
            <div
              v-else
              class="no-data"
            >
              <div class="no-data-img">
                <img
                  src="@/assets/images/no-data.png"
                  class="img"
                >
              </div>
              <div class="no-data-txt">
                暂无数据
              </div>
            </div>
          </div>
          <div class="wx-data-uv-item">
            <div
              v-if="wxDataUv2.length > 0"
              :class="wxDataUv2.length > 0 ? 'show-chart' : ''"
            >
              <mk-pie
                :data="wxDataUv2"
                :tooltip="tooltip"
                :options="uvOptions2"
                :transform="transform"
              ></mk-pie>
            </div>
            <div
              v-else
              class="no-data"
            >
              <div class="no-data-img">
                <img
                  src="@/assets/images/no-data.png"
                  class="img"
                >
              </div>
              <div class="no-data-txt">
                暂无数据
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    wxDataPv1: {
      type: Array,
      default () {
        return [
          // { item: '朋友圈', count: 40 },
          // { item: '分享微信好友', count: 20 }
        ]
      }
    },
    pvOptions1: {
      type: Object,
      default () {
        return {}
      }
    },
    wxDataPv2: {
      type: Array,
      default () {
        return [
          // { item: '转发', count: 40 },
          // { item: '销售直接转发', count: 20 }
        ]
      }
    },
    pvOptions2: {
      type: Object,
      default () {
        return {}
      }
    },
    wxDataUv1: {
      type: Array,
      default () {
        return [
          // { item: '老线索', count: 20 },
          // { item: '新线索', count: 40 }
        ]
      }
    },
    uvOptions1: {
      type: Object,
      default () {
        return {}
      }
    },
    wxDataUv2: {
      type: Array,
      default () {
        return [
          // { item: '微信好友', count: 40 },
          // { item: '非微信好友', count: 20 }
        ]
      }
    },
    uvOptions2: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      tooltip: [
        'item*percent*count',
        (item, percent, count) => {
          percent = (percent * 100).toFixed(2) + '%'
          return {
            name: item,
            value: '数量:' + count + ',占比:' + percent
          }
        }
      ],
      transform: {
        type: 'percent',
        field: 'count',
        dimension: 'item',
        as: 'percent'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.channel {
  // width: calc(100% - 32px);
  // margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .sale-clue {
    margin-right: 20px;
  }

  /deep/ .g-guide {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
  }

  .channel-pv {
    // margin-top: 32px;
    position: relative;
    z-index: 8;
  }

  .channel-pv,
  .channel-uv {
    .title {
      font-size: 16px;
      font-weight: 500;
      position: relative;
      z-index: 999;
      // cursor: pointer;
      display: inline-flex;
    }

    .tips {
      display: flex;
      align-items: center;

      i {
        display: block;
        width: 4px;
        height: 16px;
        background-color: #009cff;
        border-radius: 1px;
        margin-right: 8px;
      }

      span {
        font-size: 13px;
        line-height: 13px;
        color: #262626;
        font-weight: 500;
      }
    }

    .wx-data-pv {
      display: flex;

      .wx-data-pv-item {
        width: 400px;
      }

      .show-chart {
        flex: 0;
        margin-top: -88px;
      }
    }

    .wx-data-uv {
      display: flex;

      .wx-data-uv-item {
        width: 400px;
        // flex: 0;
        // margin-top: -88px;
      }

      .show-chart {
        flex: 0;
        margin-top: -88px;
      }
    }

    .no-data {
      display: flex;
      flex-direction: column;
      align-items: center;
      // padding-bottom: 100px;
      padding: 50px 0;

      .no-data-img {
        width: 80px;
        height: 59px;

        .img {
          width: 100%;
          height: 100%;
        }
      }

      .no-data-txt {
        font-size: 14px;
        margin-top: 12px;
        color: #bfbfbf;
      }
    }
  }
}
</style>
